const FormSidebar = ({ children }) => (
    <div className="new-form-sidebar">
        <div className="new-form-sidebar-inner">{children}</div>
        <div className="new-form-sidebar__gradient" />
    </div>
);

export default FormSidebar;
